// Grids & Gantts — the one stylesheet laid over the product's create screen
// (CreateIssueModal) wherever this module opens it: the grid's "+" and the
// work item pop-up's own "+".
//
// THE LAYERS. Grids & Gantts draws its dialogs at 4000 and up (Sheet, the
// pop-up, the clone panel). The product's work-item layers that portal to
// <body> sit at 1000–2200 — the create screen, a transition screen, the
// select and typeahead dropdowns, the attachment viewer. Opened from inside
// the pop-up, they went UNDER it: the create screen was there, behind the
// work item, and could not be reached. While this stylesheet is mounted they
// are lifted above 4000, in the same order they had among themselves —
// the validator-recovery screen ("fill these in") over the create screen
// that opened it, its dropdowns over it.
//
// THE LOOK. A long single column of full-width boxes with a thick red ring
// around every demanded field read as an error page. The screen is wider,
// two columns at a desk (summary and description keep the whole width), and
// a demanded field is marked by a red edge on its own control and a red
// asterisk — still impossible to miss, no longer shouting.
export const CREATE_SCREEN_CSS = `
  .modal-overlay { z-index: 4300 !important; }
  .vrm-overlay { z-index: 4350 !important; }
  .ss-dropdown, .typeahead-dropdown { z-index: 4400 !important; }
  .att-preview-overlay { z-index: 4500 !important; }

  .create-issue-modal.create-issue-has-lines { max-width: min(1200px, 96vw) !important; }
  .create-issue-modal {
    max-width: 780px !important; width: 100%;
    border-radius: 16px !important; border: 1px solid var(--border) !important;
    box-shadow: 0 24px 64px rgba(15, 23, 42, 0.28) !important;
  }
  .create-issue-modal .modal-header {
    position: sticky; top: 0; z-index: 3;
    padding: 16px 22px; background: var(--bg-secondary);
  }
  .create-issue-modal .modal-body { padding: 18px 22px 10px; }
  .create-issue-modal .create-issue-link-banner { border-radius: 10px; margin-bottom: 14px; }
  .create-issue-modal .create-issue-type-row { margin-bottom: 14px; }
  .create-issue-modal .create-issue-label { display: inline-flex; align-items: baseline; gap: 2px; margin-bottom: 2px; }
  .create-issue-modal .create-issue-input,
  .create-issue-modal .create-issue-select,
  .create-issue-modal .ss-trigger { border-radius: 8px; min-height: 38px; }
  .create-issue-modal .create-issue-description { border-radius: 8px; }

  @media (min-width: 720px) {
    .create-issue-modal .create-issue-fields {
      display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 14px 18px;
    }
    .create-issue-modal .create-issue-field:first-child,
    .create-issue-modal .create-issue-field:has(.create-issue-description),
    .create-issue-modal .create-issue-field:has(textarea) { grid-column: 1 / -1; }
  }

  .create-issue-modal .create-issue-required { color: var(--danger, #dc2626); font-weight: 800; }
  .create-issue-modal .create-issue-field:has(.create-issue-required) :is(.create-issue-input, .create-issue-select, .ss-trigger, .create-issue-description) {
    border-color: rgba(220, 38, 38, 0.45);
    box-shadow: inset 3px 0 0 var(--danger, #dc2626);
  }

  .create-issue-modal .modal-footer {
    position: sticky; bottom: 0; z-index: 3;
    display: flex; justify-content: flex-end; gap: 0.75rem; padding: 14px 22px;
    border-top: 1px solid var(--border); background: var(--bg-secondary);
  }
  .create-issue-modal .cancel-button {
    background: transparent; border: 1px solid var(--border); color: var(--text-secondary);
    padding: 0.6rem 1.2rem; border-radius: 8px; font-size: 0.875rem; cursor: pointer; transition: all 0.2s;
  }
  .create-issue-modal .cancel-button:hover:not(:disabled) { border-color: var(--text-primary); color: var(--text-primary); }
  .create-issue-modal .save-button {
    background: var(--accent); border: none; color: white; padding: 0.6rem 1.5rem;
    border-radius: 8px; font-size: 0.875rem; font-weight: 600; cursor: pointer; transition: all 0.2s;
  }
  .create-issue-modal .save-button:hover:not(:disabled) { background: var(--accent-hover); }
  .create-issue-modal .save-button:disabled, .create-issue-modal .cancel-button:disabled { opacity: 0.5; cursor: not-allowed; }
`;
